import { SearchTerm } from './SearchTerm';

const DepartmentSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "deptName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default DepartmentSearch;
